import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../views/Layout.vue'

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'Index',
        meta: {
          title: '首页'
        },
        component: () => import('../views/Index.vue')
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/lygame',
    children: [
      {
        path: 'lygame',
        name: 'LyGame',
        meta: {
          title: '联运游戏'
        },
        component: () => import('../views/LyGame.vue')
      },
      {
        path: 'appcontractlist',
        name: 'AppContractList',
        meta: {
          title: '联运SDK'
        },
        component: () => import('../views/AppContractList.vue')
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/newlygame',
    children: [
      {
        path: 'newlygame',
        name: 'newLyGame',
        meta: {
          title: '新联运游戏'
        },
        component: () => import('../views/LyGame.vue')
      },
      {
        path: 'appcontractlist',
        name: 'AppContractList',
        meta: {
          title: '联运SDK'
        },
        component: () => import('../views/AppContractList.vue')
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/unifiedpackagegame',
    children: [
      {
        path: 'unifiedpackagegame',
        name: 'UnifiedPackageGame',
        meta: {
          title: '统一包游戏'
        },
        component: () => import('../views/UnifiedPackageGame.vue')
      },
      {
        path: 'unifiedpackagecontractlist/:appId?',
        name: 'UnifiedPackageContractList',
        meta: {
          title: '统一包SDK'
        },
        component: () => import('../views/UnifiedPackageContractList.vue')
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/lyapp',
    children: [
      {
        path: 'lyapp',
        name: 'LyApp',
        meta: {
          title: '联运应用'
        },
        component: () => import('../views/LyApp.vue')
      },
      {
        path: 'appcontractlist/:appId?',
        name: 'AppContractList',
        meta: {
          title: '联运SDK'
        },
        component: () => import('../views/AppContractList.vue')
      },
      {
        path: 'mimoContract/:type?',
        name: 'MimoContract',
        meta: {
          title: '米盟合同'
        },
        component: () => import('../views/mimoContract/index.vue')
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/userinfo',
    children: [
      {
        path: 'userinfo',
        name: 'User',
        meta: {
          title: '联运账户信息'
        },
        component: () => import('../views/User.vue')
      },
      {
        path: 'mimouserinfo',
        name: 'MimoUser',
        meta: {
          title: '联运账户信息'
        },
        component: () => import('../views/MimoUser.vue')
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/question',
    children: [
      {
        path: 'question',
        name: 'Question',
        meta: {
          title: '疑问解答'
        },
        component: () => import('../views/Question.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
